<div class="main-wrapper">
     <div class="btndivposition btnalignmentleft">
      <a class="link" href="assets/DATA_BREACH_CERTIFICATION.pdf" target="_blank">Data Breach Certificate</a>
      </div>
      <div class="btndivposition btnalignmentright">
      <a class="link" href="assets/Complinity_Spring_releasenotes.pdf" target="_blank">Release Notes</a>

      &nbsp;&nbsp; <a class="link" href="https://www.youtube.com/watch?v=1B2WkmYLV3g" target="_blank">Release Training Video</a>

      </div>


      <div class="trainingmsg">
       <p class="textaligncenter fontwight300" [innerHTML]="trainingannouncementmsg"></p>
       </div>

  <div class="login-section">
    <div class="login-card">
      <!-- Logo Section -->
      <div class="logo-container" >
        <img [src]="logoUrl" 
    alt="Complinity" 
    [style.width]="logoWidth"/>
     <p *ngIf="!isanotherorg">Compliance & Risk Simplified</p>

       
        <!-- <div class="logo-wrapper">
   <div class="brand-name">
    compl<span class="dot">i</span>n<span class="dot">i</span>ty<span class="reg">®</span>
    <div class="version">V 3.7</div>
  </div>
</div> -->
      </div>
<div *ngIf="!invalidssologin">

      <h2>Welcome Back!</h2>
      <!-- <div class="info-alert-box">
  <i class="info-icon">i</i> 
  <span>
    If you've forgotten your password, please enter your email and click 
    <a href="#" class="reset-link">Reset Password</a>
  </span>
</div> -->
   <!-- <p class="redtext">**If you are not aware of your password, please enter your Email address and click on Reset Password</p> -->


      <form class="login-form"  [formGroup]="loginForm">
        <div class="input-group">
          <label>Email</label>
          <input type="email" placeholder="Enter your email" formControlName="useremail" name="useremail" id="useremail"
          [class.is-invalid]="loginForm.get('useremail').invalid && (loginForm.get('useremail').dirty || loginForm.get('useremail').touched)"
          [class.is-valid]="loginForm.get('useremail').valid" autocomplete="username" [(ngModel)]="autoFill.email" #userEmailInput>
            <p class="invaliduseremail"
                    *ngIf="loginForm.get('useremail').invalid && (loginForm.get('useremail').dirty || loginForm.get('useremail').touched)">
                    {{getErrorMessage(loginForm ,validation_message,'useremail')}}
        </p>
        </div>

        <div class="input-group">
          <label>Password</label>
          <input [type]="showPassword ? 'text' : 'password'"type="password" placeholder="Enter your password" formControlName="userpassword" name="userpassword"id="userpassword"
          class="form-control" [class.is-invalid]="loginForm.get('userpassword').invalid && (loginForm.get('userpassword').dirty || loginForm.get('userpassword').touched)"
          [class.is-valid]="loginForm.get('userpassword').valid" autocomplete="current-password" [(ngModel)]="autoFill.password">
              <i class="pi"[ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"
                        (click)="togglePassword()">
                    </i>
            <p class="invaliduseremail"
                    *ngIf="loginForm.get('userpassword').invalid && (loginForm.get('userpassword').dirty || loginForm.get('userpassword').touched)">
                    {{getErrorMessage(loginForm ,validation_message,'userpassword')}}
        </p>
        </div>
          <div class="grid" >
                    <span class="termsspan">By continuing , you agree to Complinity`s <a class="termspolicy" href="assets/terms_of_service(ToS).pdf"  target="_blank">Terms of service</a> and <a class="termspolicy" href="assets/privacy_policy.pdf"  target="_blank">Privacy Policy</a></span>
                </div>
 <div class="info-alert-box">
  <i class="info-icon">i</i> 
  <span>
    If you've forgotten your password, please enter your email and click 
    <a href="javascript:void(0)" class="reset-link"(click)="openCaptcha(ismfenable,'Reset Password')">Reset Password</a>
  </span>
</div>
        <button type="submit" class=" login-btn" (click)="login()" [disabled]="loginForm.invalid">Login</button>
        <span><p class="or-p">OR</p></span>
         <button type="submit" class=" login-btn" (click)="ssologinredirect()" [disabled]="ssoenable">SSO Login</button>

      </form>
<div class="logo-container" *ngIf="isanotherorg">
        <img src="https://pbcomplinity.s3.ap-south-1.amazonaws.com/images/logo.png" alt="Complinity" style="margin-top:5%;">
        <p >Compliance & Risk Simplified</p>
</div>

      <!-- Announcements Section -->
    <!--
      <div class="announcement-box">
        <div class="ann-header">Latest Announcements</div>
        <div class="ann-content">
          <div class="ann-item">
            <strong>New Feature: Automated Compliance</strong> 
             <p>Generate reports with just one click!</p> 
             <p class="textaligncenter fontwight700" [innerHTML]="trainingannouncementmsg"></p>

          </div>
           <div class="ann-item">
            <strong>Scheduled Maintenance</strong>
            <p>System maintenance on May 15th, 2:00 AM.</p>
          </div> 
        </div>
      <a href="#" class="view-all">View All Announcements ></a> 
      </div>
    -->
    </div>
      <div *ngIf="invalidssologin" class="sso-error-box">
         <div >
    <div class="icon">
      <!-- Warning Icon -->
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M12 2L1 21H23L12 2Z" stroke="#d13438" stroke-width="2"/>
        <line x1="12" y1="8" x2="12" y2="14" stroke="#d13438" stroke-width="2"/>
        <circle cx="12" cy="17" r="1.5" fill="#d13438"/>
      </svg>
    </div>
<h3>Unable to Sign In</h3>
    <p>We are not able to fetch your email details from received token. Please try again later or contact to administrator.</p>
  </div>
    </div>


    <!-- hide form -->

     <!-- <div *ngIf="loginformhide" class="sso-error-box">
         <div >
    <div class="icon">
   
    </div>
<h2>Direct login is not available for your account. Your organization requires Single Sign-On (SSO)</h2>
    <p>Please use the SSO Log In option to continue.</p>
             <button type="submit" class=" login-btn" (click)="ssologinredirect()" [disabled]="ssoenable">SSO Login</button>

  </div>
    </div> -->
    </div>
  
  </div>
</div>
